import { fetchNewPosts } from "@/api/endpoints";
import { IPosts, IPostTrade } from "@/shared";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useSocialStore = defineStore("Social", () => {
	// const count = ref(0);
	const postsIds = ref<string[]>([]);
	const postsData = ref<{ [i: string]: IPostTrade }>({});

	function getPosts() {
		postsIds.value = ["1", "2"];
	}
	async function getPost(id: string) {
		// console.log(await fetchNewPosts());
		await new Promise((resolve) => setTimeout(resolve, 2000));
		postsData.value[id] = {
			id,
			description: "Minimized the pain :(",
			bought: 0,
			sold: 5.98,
			holding: 10.21,
			pnl: -3.45,
			pnlPercent: -32.45,
			marketCap: 488995454.45484,
			createdAt: Date.now(),
			user: {
				address: "5ucHZJk4QByiSkGDEu9cpwrTFwVh5YJWmRDtsReF3vqA",
				name: "CHRISSGON",
				image: "logo_sm.png",
			},
			token: {
				mint: "So11111111111111111111111111111111111111112",
				name: "SOL",
			},
			comments: [],
		};
	}
	async function getPostComments(id: string) {
		await new Promise((resolve) => setTimeout(resolve, 2000));
		postsData.value[id].comments = [
			{
				createdAt: Date.now(),
				comment: "Really nice trade :)",
				user: {
					address: "5ucHZJk4QByiSkGDEu9cpwrTFwVh5YJWmRDtsReF3vqA",
					name: "CHRISSGON",
					image: "logo_sm.png",
				},
			},
			{
				createdAt: Date.now(),
				comment: "Unfortunately I did the same mistake :(",
				user: {
					address: "5ucHZJk4QByiSkGDEu9cpwrTFwVh5YJWmRDtsReF3vqA",
					name: "Tester03",
					image: "logo_sm.png",
				},
			},
		];
	}

	// setup
	getPosts();

	return { postsIds, postsData, getPosts, getPost, getPostComments };
});
